<style lang="less" scoped>
  .user-flow-container{
    font-size: 12px;
    position: relative;
    .v-btn {
      padding: 0;
    }
    .failed-content{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(55,55,55, .4);
      .failed-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .node-name{
    font-weight: bold;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .ivu-btn-small{
    padding: 1px 4px;
    line-height: 1.2;
    font-size: 12px;
    margin-right: 1px;
    height: 20px;
  }
  .node-user-multi{
    border-top: 1px solid #dddee1;
    margin-top: 2px;
    padding-top: 2px;
  }
  .user-name {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 55px;
    display: inline-block;
    white-space: nowrap;
    vertical-align: top;
  }
</style>
<template>
  <div class="user-flow-container text-left">
    <div v-show="user_flow.del_user_id > 0">
      <div class="color-grey">
        {{ $util.formatTime(user_flow.del_at) }}
      </div>
      <div
        class="node-name"
        @click="showUserFlow"
      >
        {{ cur_node_name }}
      </div>
      <CustomerName :id="user_flow.del_user_id" />
      <span class="color-error">[已废弃]</span>
      <div class="">
        废弃原因: {{ user_flow.del_reason || '未填写' }}
      </div>
    </div>
    <div v-show="user_flow.del_user_id === 0">
      <div class="">
        <div class="color-grey">
          {{ $util.formatTime(cur_user_node.handled_at || cur_user_node.updated_at) }}
        </div>
        <div
          class="node-name"
          @click="showUserFlow"
        >
          {{ cur_node_name }}
        </div>
      </div>
      <div
        v-if="cur_node_desc"
        class="color-warning"
      >
        {{ cur_node_desc }}
      </div>
      <div
        v-for="node_user in user_node_users"
        :key="node_user.id"
        class="node-user"
      >
        <CustomerName :id="node_user.customer_id" />
        [<span v-html="userFlowNodeUserStatusHtml(node_user, cur_user_node)" />]
        <div v-if="show_handles && canCheckFlow(node_user)">
          <v-btn-toggle>
            <v-btn
              x-small
              depressed
              color="primary"
              @click="showPassModal(node_user)"
            >
              {{ getPassText(node_user.action_type) }}
            </v-btn>
            <v-btn
              x-small
              depressed
              color="warning"
              :disabled="canNotFailNode(node_user)"
              @click="showFailModal(node_user)"
            >
              <span>驳回</span>
            </v-btn>
            <v-menu
              v-show="show_others"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  depressed
                  v-bind="attrs"
                  v-on="on"
                >
                  其他
                </v-btn>
              </template>
              <v-list
                dense
              >
                <v-list-item
                  v-if="canInviteUser(node_user.action_type)"
                  link
                  @click="showInviteModal(node_user)"
                >
                  邀请
                </v-list-item>
                <v-list-item
                  link
                  @click="showTransferModal(node_user)"
                >
                  转移
                </v-list-item>
                <v-list-item
                  v-if="can_hold"
                  link
                  @click="showHoldModal(node_user)"
                >
                  HOLD
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn-toggle>
        </div>
      </div>
      <div v-if="show_extra_fail_btn">
        <v-btn
          x-small
          color="warning"
          @click="showFailModal({comment: ''})"
        >
          驳回
        </v-btn>
      </div>
    </div>
    <Spin
      v-if="loading"
      fix
    />
    <div
      v-if="!loading && load_failed"
      class="failed-content"
    >
      <Button
        class="failed-btn"
        size="small"
        type="warning"
        @click="updateUserFlow"
      >
        重新加载
      </Button>
    </div>
  </div>
</template>
<script>
  import FlowUtil from '../../../libs/flow_util';
  export default {
    props: {
      user_flow: {
        type: Object,
        required: true
      },
      modelC: {
        type: Object,
        required: true
      },
      show_handles: {
        type: Boolean,
        default: () => true
      },
      show_others: {
        type: Boolean,
        default: () => true
      },
      // 完成后n秒内还能驳回，0 不能驳回
      secondsAllowedToFailAfterFinished: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loading: false,
        load_failed: false
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      cur_user_node() {
        return this.user_flow.current_user_flow_node || {};
      },
      flow_node() {
        return this.cur_user_node.flow_node || {}
      },
      cur_node_name() {
        return this.cur_user_node.flow_node_name;
      },
      cur_node_desc() {
        return this.cur_user_node.flow_node.desc;
      },
      user_node_users() {
        return this.cur_user_node.user_flow_node_users;
      },
      can_hold() {
        const { forbid_fail } = this.flow_node
        if (forbid_fail) {
          return false
        }
        return this.cur_user_node.return_flow_node_id === 0;
      },
      show_extra_fail_btn() {
        const seconds = this.secondsAllowedToFailAfterFinished;
        const finished = this.user_flow.is_finish;
        if (!seconds || !finished) return false;
        const finished_at = this.user_flow.finished_at;
        if (!finished_at) return false;
        const finished_time = new Date(finished_at).getTime();
        const expired_time = finished_time + seconds * 1000;
        const now = new Date().getTime();
        return now < expired_time;
      }
    },
    watch: {
      user_flow(new_user_flow, old_user_flow) {
        this.removeEventListener(old_user_flow);
        this.addEventListener(new_user_flow);
      }
    },
    created() {
      // console.log('user_flow', this.user_flow)
      //
    },
    mounted() {
      this.addEventListener(this.user_flow);
    },
    beforeDestroy() {
      this.removeEventListener(this.user_flow);
    },
    methods: {
      addEventListener(user_flow) {
        if (user_flow && user_flow.id) {
          window.eventHub.$on(`update-user-flow-base-${user_flow.id}`, this.updateUserFlow);
        }
      },
      removeEventListener(user_flow) {
        if (user_flow && user_flow.id) {
          window.eventHub.$off(`update-user-flow-base-${user_flow.id}`, this.updateUserFlow);
        }
      },
      showPassModal(node_user) {
        window.eventHub.$emit('show-user-flow-handler', 'pass', this.user_flow.id, node_user);
      },
      showFailModal(node_user) {
        window.eventHub.$emit('show-user-flow-handler', 'fail', this.user_flow.id, node_user);
      },
      showInviteModal(node_user) {
        window.eventHub.$emit('show-user-flow-handler', 'invite', this.user_flow.id, node_user);
      },
      showTransferModal(node_user) {
        window.eventHub.$emit('show-user-flow-handler', 'transfer', this.user_flow.id, node_user);
      },
      showHoldModal(node_user) {
        window.eventHub.$emit('show-user-flow-handler', 'hold', this.user_flow.id, node_user);
      },
      showUserFlow() {
        window.eventHub.$emit('show-user-flow', this.user_flow.id);
      },
      userFlowNodeUserStatusHtml(user_flow_node_user, user_flow_node) {
        return FlowUtil.userFlowNodeUserStatusHtml(user_flow_node_user, user_flow_node);
      },
      getPassText(action_type) {
        return FlowUtil.getPassText(action_type);
      },
      canCheckFlow(node_user) {
        // 节点待处理中
        const pending = node_user.status === 0;
        // 关联模型未废弃
        const un_del = this.modelC && !this.modelC.del;
        // 是否是当前用户
        const is_cur_user = node_user.customer_id === this.cur_customer.id;
        return pending && un_del && is_cur_user;
      },
      canNotFailNode(node_user) {
        const { action_type } = node_user
        const { forbid_fail } = this.flow_node
        return action_type === 'submit' || forbid_fail;
      },
      canInviteUser(action_type) {
        return action_type === 'check';
      },
      formatDate(date) {
        return this.$util.formatDate(date);
      },
      updateUserFlow() {
        this.loading = true;
        FlowUtil.getUserFlowBaseInfo(this.user_flow.id).then((user_flow) => {
          Object.keys(this.user_flow).forEach((key) => {
            this.user_flow[key] = user_flow[key];
          });
          this.load_failed = false;
          this.$emit('on-change', user_flow);
        }).catch((e) => {
          console.log(e);
          this.load_failed = true;
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>
